import {cssWidthToPixelWidth} from "shared/helpers/utils/DOM";
import styles from "../../ui/styles/constants.module.scss";

export const TABLE_WIDTH = cssWidthToPixelWidth(styles.tableWidth);